import experimentSingleton from '../vendor/experiment.vendor'

export const ORDERS_LIST_FEATURE_FLAGS = {
  OrdersListNewLayoutEnabled: 'orders_list_new_layout_enabled'
}

async function isOrdersListNewLayoutFlagEnabled () {
  return await experimentSingleton.isFlagActive(
    ORDERS_LIST_FEATURE_FLAGS.OrdersListNewLayoutEnabled
  )
}

export { isOrdersListNewLayoutFlagEnabled }
